export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000' as const;

/**
 *
 */

export const DEFAULT_APP_CONFIGURATION_ID =
    '74b70000-8c85-00ff-9055-08dd6828f411' as const;

export const FileContentType = {
    DOC: 'application/msword',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    PDF: 'application/pdf',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    XLS: 'application/vnd.ms-excel',
    CSV: 'text/csv',
    PPT: 'application/vnd.ms-powerpoint',
    PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ZIP: 'application/zip',
    RAR: 'application/x-rar-compressed',
    GIF: 'image/gif',
    BMP: 'image/bmp',
    SVG: 'image/svg+xml',
    JPG: 'image/jpeg',
    JPEG: 'image/jpeg',
    PNG: 'image/png',
    TIFF: 'image/tiff',

    XML: 'text/xml',
    JSON: 'application/json',
    HTML: 'text/html',
    TXT: 'text/plain',
    MP4: 'video/mp4',
    MP3: 'audio/mpeg',
    WAV: 'audio/wav',
} as const;

export const ArrFileContentType = Object.values(FileContentType);

export const DEFAULT_ADDRESS = {
    Nationality: 'Việt Nam', // ✅ Chính xác
    NationalityCode: 'VN', // ✅ Chuẩn ISO 3166-1 alpha-2
    Country: 'Việt Nam', // ✅ Chính xác
    CountryCode: 'VN', // ✅ Trùng với NationalityCode, thường là như vậy
    PostalCode: '700000', // ✅ Đây là mã bưu chính của TP.HCM,
};
